import { styled, Switch as MuiSwitch, SwitchProps } from "@mui/material";

const SketchySwitch = styled(MuiSwitch)(({ theme }) => ({
    width: 48,
    height: 26,
    padding: 0,
    margin: 8,
    "& .MuiSwitch-switchBase": {
        padding: 1,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(22px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: "var(--fq-accent-warm)",
                opacity: 1,
                border: "2px solid var(--fq-primary-text-color)",
            },
            "& .MuiSwitch-thumb": {
                backgroundColor: "#fff",
                border: "2px solid var(--fq-primary-text-color)",
            },
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 18,
        height: 18,
        backgroundColor: "var(--fq-card-bg)",
        border: "2px solid var(--fq-primary-text-color)",
        borderRadius: "40% 60% 50% 50% / 50% 50% 40% 60%", // Irregular circle
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: "var(--fq-hover-color-1)",
        opacity: 1,
        border: "2px solid var(--fq-primary-text-color)",
        transition: theme.transitions.create(["background-color", "border"]),
        boxSizing: "border-box",
    },
}));

export default function Switch(props: SwitchProps) {
    return <SketchySwitch {...props} />;
}
